// src/components/Admin/UserManager/UserPointLogs.jsx
import React, { useState, useEffect } from 'react';
import {
    Paper, Table, TableHead, TableRow,
    TableCell, TableBody, CircularProgress, Typography,
    Box,
} from '@mui/material';
import dayjs from 'dayjs';
import api from '../../../api/axios';

export default function UserPointLogs({ userId }) {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get(`/api/management/users/${userId}/point-logs/`)
            .then((res) => setLogs(res.data.logs || []))
            .catch(() => setLogs([]))
            .finally(() => setLoading(false));
    }, [userId]);

    if (loading) {
        return <CircularProgress sx={{ mt: 4, display: 'block', mx: 'auto' }} />;
    }

    if (logs.length === 0) {
        return <Typography sx={{ mt: 2 }}>포인트 로그가 없습니다.</Typography>;
    }

    return (
        <Box
            sx={{
                /* 모바일: 90 % 축소 & 좌상단 기준 */
                '@media (max-width:600px)': {
                    transform: 'scale(0.9)',
                    transformOrigin: 'top left',
                },
            }}
        >
            <Paper
                variant="outlined"
                sx={{
                    '& td, & th': {
                        textAlign: 'center',
                        p: 1.25,
                        whiteSpace: 'nowrap',
                        borderBottom: '1px solid #eee',
                        /* 모바일: 패딩·폰트 축소 */
                        '@media (max-width:600px)': {
                            p: 0.75,
                            fontSize: '0.8rem',
                        },
                    },
                    '& th': { bgcolor: 'grey.50', fontWeight: 'bold' },
                }}
            >
                <Table size="small" stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell width={160}>날짜</TableCell>
                            <TableCell width={120}>구분</TableCell>
                            <TableCell width={120}>금액</TableCell>
                            <TableCell width={260}>설명</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {logs.map((log) => (
                            <TableRow key={log.id}>
                                <TableCell>
                                    {dayjs(log.date).format('YYYY-MM-DD HH:mm')}
                                </TableCell>
                                <TableCell>
                                    {log.point_type === 'earn' ? '지급' : '차감'}
                                </TableCell>
                                <TableCell>
                                    {`${log.amount > 0 ? '+' : ''}${log.amount.toLocaleString()} Leaf🌿`}
                                </TableCell>
                                <TableCell>{log.description || '-'}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Paper>
        </Box>
    );
}
